import { render, staticRenderFns } from "./top-bar-administration-menu.vue?vue&type=template&id=a0e6e158&"
import script from "./top-bar-administration-menu.vue?vue&type=script&lang=js&"
export * from "./top-bar-administration-menu.vue?vue&type=script&lang=js&"
import style0 from "./top-bar-administration-menu.vue?vue&type=style&index=0&id=a0e6e158&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports